import React, { useState } from 'react';
import cn from 'classnames';
import Tag from 'components/UI/Tag';
import { useTrans } from 'utils/localisation';

import * as styles from './details.module.scss';

export function Component({ content, className }) {
  const [showPopup, setShowPopup] = useState(false);
  const t = useTrans(['common']);

  return (
    <div className={cn(className, styles.wrapper)}>
      {content.map(({ type, title, description, items, hiddenContent }) => (
        <div key={type} className={styles.row}>
          <span className={styles.title}>{title}</span>
          {type === 'technologies' ? (
            <div className={styles.technologiesWrapper}>
              {items?.map(technology => (
                <Tag key={technology} theme="oval" className={styles.tag}>
                  {technology}
                </Tag>
              ))}
              {hiddenContent && (
                <div className={styles.hiddenContent}>
                  <button
                    className={cn(styles.viewButton, showPopup && styles.hide)}
                    onClick={() => setShowPopup(!showPopup)}
                  >
                    {showPopup ? t('hideAll') : t('viewAll')}
                  </button>
                  <div className={cn(styles.popUp, showPopup && styles.visible)}>
                    {hiddenContent.map(({ title, description }) => (
                      <div key={title} className={styles.popUpSection}>
                        {title && <p>{title}</p>}
                        <p>{description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <span className={styles.description}>{description}</span>
          )}
        </div>
      ))}
    </div>
  );
}
